module.exports = __webpack_public_path__ + "img/E-WEB-Goal-4.d9c14540.png";